import * as React from 'react';
import { BUMP_INCREMENT_AMOUNT_PERCENT, MIN_BUMP_AMOUNT_PERCENT, MAX_BUMP_AMOUNT_PERCENT } from '../shared/constants';


function Options() {

  const options = [];

  for (let percent = MIN_BUMP_AMOUNT_PERCENT; percent <= MAX_BUMP_AMOUNT_PERCENT; percent += BUMP_INCREMENT_AMOUNT_PERCENT) {
    const value = (percent / 100);
    options.push(
      <option
        value={value}
        key={value}
      >
        {`${percent}%`}
      </option>,
    );
  }

  return (
    <>
      {options}
    </>
  );
}

interface CustomSelectProps {
  customSelected: boolean;
  value: number;
  onChange: (event) => void;
}

export interface OptionProps {
  text: string;
  value: number;
}

export function CustomSelect(props: CustomSelectProps) {
  if (!props.customSelected) return null;

  return (
    <div className="bump-split-button__custom-field">
      <div className="styled-dropdown styled-dropdown--fluid mb-0">
        <select
          name="bid"
          value={props.value}
          onChange={props.onChange}
        >
          <Options />
        </select>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/bump/custom_select.tsx